import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PROVET_EXPLORER_REPOSITORY } from '../domain/repositories/provet-explorer.repository';
import { ProvetExplorerProxyRemoteDatasource } from './datasources/remote/provet-explorer-proxy.remote-datasource';
import { ProvetExplorerRepositoryImpl } from './repositories/provet-explorer.repository.impl';

export function provideProvetExplorerData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ProvetExplorerProxyRemoteDatasource,
    { provide: PROVET_EXPLORER_REPOSITORY, useClass: ProvetExplorerRepositoryImpl },
  ]);
}
